<template>
  <div>
    <SfBreadcrumbs class="breadcrumbs desktop-only container-xl" :breadcrumbs="breadcrumbs">
      <template #link="{breadcrumb}">
        <router-link :to="breadcrumb.route.link" class="sf-breadcrumbs__breadcrumb">
          {{ breadcrumb.text }}
        </router-link>
      </template>
    </SfBreadcrumbs>

    <section class="section-contacts col-layout container-xl">
      <h1 class="page-title h2">
        {{ $t(title) }}
      </h1>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <div v-if="description" v-html="description" class="description" />
          <form @submit.prevent="sendMessage" novalidate="novalidate">
            <SfInput
              type="text"
              name="name"
              autocomplete="name"
              required="required"
              v-model="name"
              :label="$t('Name')"
            />
            <SfInput
              type="email"
              name="email"
              autocomplete="email"
              required="required"
              v-model="email"
              :label="$t('E-mail address')"
            />
            <SfInput
              type="tel"
              name="telephone"
              autocomplete="tel"
              v-model="telephone"
              :label="$t('Phone Number')"
            />
            <textarea
              name="comment"
              row="3"
              v-model="message"
              :placeholder="$t('Kommentar')"
            />

            <div class="action">
              <p class="required-fields-notice">
                <small>* Pflichtfelder</small>
              </p>
              <SfButton type="submit" class="btn btn-primary">
                Absenden
              </SfButton>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { EmailForm } from '@vue-storefront/core/modules/mailer/components/EmailForm'
import { MailerModule } from '@vue-storefront/core/modules/mailer'
import { registerModule } from '@vue-storefront/core/lib/modules'
import { mapGetters } from 'vuex'
import { SfBreadcrumbs, SfInput, SfButton } from '@storefront-ui/vue';
import i18n from '@vue-storefront/i18n';

export default {
  components: {
    SfBreadcrumbs,
    SfInput,
    SfButton
  },
  mixins: [EmailForm],
  beforeCreate () {
    registerModule(MailerModule)
  },
  data () {
    return {
      name: '',
      email: '',
      telephone: '',
      message: ''
    }
  },
  props: ['page', 'title'],
  computed: {
    ...mapGetters({
      storeConfig: 'storeConfig/getConfigValue'
    }),
    description () {
      return false
    },
    breadcrumbs () {
      return [
        { text: i18n.t('ruckzuck.store'), route: { link: this.localizedRoute('/') } },
        { text: i18n.t('Contacts') }
      ];
    }
  },
  methods: {
    sendMessage () {
      this.sendEmail(
        {
          sourceAddress: this.email,
          targetAddress: 'verkauf@ruckzuck.store', // this.storeConfig('contact/email/recipient_email'),
          subject: this.$t('Contact Form Request'),
          emailText: this.buildMessage()
        },
        this.onSuccess,
        this.onFailure
      )
    },
    buildMessage () {
      return Object
        .entries(this._data)
        .flatMap((v) => v[0].charAt(0).toUpperCase() + v[0].slice(1) + ': ' + v[1]).join('\n')
    },
    onSuccess (message) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message,
        action1: { label: this.$t('OK') }
      })
    },
    onFailure (message) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'error',
        message,
        action1: { label: this.$t('OK') }
      })
    }
  }
}
</script>
